/**
 * Labstep
 *
 * @module components/Experiment/Form/ShowEdit/Dates
 * @desc Showing started_at and ended_at show edits
 */

import { ExperimentFormShowEditEndedAt } from 'labstep-web/components/Experiment/Form/ShowEdit/EndedAt';
import { ExperimentFormShowEditStartedAt } from 'labstep-web/components/Experiment/Form/ShowEdit/StartedAt';
import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import type { ExperimentFormShowEditDatesProps } from './types';

export const ExperimentFormShowEditDates: React.FC<
  ExperimentFormShowEditDatesProps
> = ({ experiment }) => (
  <Flex style={{ alignItems: 'baseline' }}>
    <Icon name="calendar alternate outline" />
    <ExperimentFormShowEditStartedAt experiment={experiment} />
    <span>-</span>
    <ExperimentFormShowEditEndedAt experiment={experiment} />
  </Flex>
);
